import type { FC } from "react";

import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

type HealthModalFooterProps = {
  setHealthModalOpen: React.Dispatch<
    React.SetStateAction<"pathology" | "allergy" | "womenHealth" | "none">
  >;
  handleSubmit: () => Promise<void>;
};

const HealthModalFooter: FC<HealthModalFooterProps> = ({
  setHealthModalOpen,
  handleSubmit,
}) => {
  return (
    <DialogFooter className="flex gap-3 px-6">
      <Button
        type="button"
        className="w-full"
        onClick={() => {
          setHealthModalOpen("none");
        }}
        variant={"outline"}
      >
        Annuler
      </Button>
      <Button
        type="submit"
        className="w-full"
        variant={"blue"}
        onClick={() => {
          handleSubmit();
        }}
      >
        Générer
      </Button>
    </DialogFooter>
  );
};

export default HealthModalFooter;
